/* =============================================================
   HEALVO — warstwa interakcji
   Bez zewnętrznych bibliotek. IntersectionObserver + Cart AJAX API.
   ============================================================= */
(function () {
  'use strict';

  var CFG = window.HEALVO || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var fmt = format || CFG.moneyFormat || '{{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function num(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var tail = parts[1] ? decimal + parts[1] : '';
      return head + tail;
    }

    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function trapFocus(container, onEscape) {
    function handler(e) {
      if (e.key === 'Escape') { onEscape(); return; }
      if (e.key !== 'Tab') return;
      var focusables = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', handler);
    return function () { document.removeEventListener('keydown', handler); };
  }

  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.style.overflow = scrollLocks > 0 ? 'hidden' : '';
  }

  /* ---------- 1. system reveal ---------- */

  function initReveal() {
    var items = $$('[data-hv-reveal]');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. header ---------- */

  function initHeader() {
    var header = $('[data-hv-header]');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-stuck', window.scrollY > 12);
      ticking = false;
    }
    update();
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
  }

  /* ---------- 3. menu mobilne ---------- */

  function initMobileNav() {
    var nav = $('[data-hv-mobile-nav]');
    if (!nav) return;
    var release = null;

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var closeBtn = $('[data-hv-nav-close]', nav);
      if (closeBtn) closeBtn.focus();
      release = trapFocus(nav, close);
    }
    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) { release(); release = null; }
      var opener = $('[data-hv-nav-open]');
      if (opener) opener.focus();
    }

    $$('[data-hv-nav-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    $$('[data-hv-nav-close], .hv-mobile-nav__scrim', nav).forEach(function (b) {
      b.addEventListener('click', close);
    });
    $$('.hv-mobile-nav__link, .hv-mobile-nav__foot a, .hv-mobile-nav__foot button', nav).forEach(function (link) {
      link.addEventListener('click', function () { setTimeout(close, 80); });
    });
  }

  /* ---------- 4. FAQ / accordion ---------- */

  function initAccordions() {
    $$('[data-hv-accordion]').forEach(function (root) {
      $$('.hv-faq__q', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (root.hasAttribute('data-hv-accordion-single') && !isOpen) {
            $$('.hv-faq__q', root).forEach(function (other) {
              if (other === btn) return;
              other.setAttribute('aria-expanded', 'false');
              var op = document.getElementById(other.getAttribute('aria-controls'));
              if (op) op.classList.remove('is-open');
            });
          }
          btn.setAttribute('aria-expanded', String(!isOpen));
          if (panel) panel.classList.toggle('is-open', !isOpen);
        });
      });
    });
  }

  /* ---------- 5. koszyk (AJAX + drawer) ---------- */

  var Cart = {
    el: null,
    release: null,

    init: function () {
      this.el = $('[data-hv-cart]');
      if (!this.el) return;
      var self = this;

      $$('[data-hv-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          self.refresh();
          self.open();
        });
      });
      $$('[data-hv-cart-close], .hv-cart__scrim', this.el).forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });

      this.el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hv-line-action]');
        if (!btn) return;
        var line = parseInt(btn.getAttribute('data-hv-line'), 10);
        var action = btn.getAttribute('data-hv-line-action');
        var qty = parseInt(btn.getAttribute('data-hv-qty'), 10) || 0;
        var next = action === 'remove' ? 0 : (action === 'plus' ? qty + 1 : Math.max(0, qty - 1));
        self.change(line, next);
      });

      $$('[data-hv-add-form]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          self.add(form);
        });
      });

      this.refresh(true);
    },

    open: function () {
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var closeBtn = $('[data-hv-cart-close]', this.el);
      if (closeBtn) closeBtn.focus();
      var self = this;
      this.release = trapFocus(this.el, function () { self.close(); });
    },

    close: function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (this.release) { this.release(); this.release = null; }
    },

    add: function (form) {
      var btn = form.querySelector('[data-hv-add-btn]');
      var errorEl = form.querySelector('[data-hv-form-error]');
      if (btn && btn.classList.contains('is-loading')) return;
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      if (errorEl) errorEl.classList.remove('is-visible');

      var self = this;
      fetch(CFG.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) {
            var msg = (r.data && (r.data.description || r.data.message)) || CFG.strings.error;
            if (errorEl) { errorEl.textContent = msg; errorEl.classList.add('is-visible'); }
            return;
          }
          self.refresh();
          self.open();
        })
        .catch(function () {
          if (errorEl) { errorEl.textContent = CFG.strings.error; errorEl.classList.add('is-visible'); }
        })
        .finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        });
    },

    change: function (line, quantity) {
      var self = this;
      this.el.classList.add('is-busy');
      fetch(CFG.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () {})
        .finally(function () { self.el.classList.remove('is-busy'); });
    },

    refresh: function (silent) {
      var self = this;
      fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.render(cart, silent); })
        .catch(function () {});
    },

    render: function (cart, silent) {
      var body = $('[data-hv-cart-items]', this.el);
      var foot = $('[data-hv-cart-foot]', this.el);
      var total = $('[data-hv-cart-total]', this.el);

      $$('[data-hv-cart-count]').forEach(function (el) {
        var count = cart.item_count || 0;
        el.textContent = count;
        el.hidden = count === 0;
        if (!silent && count > 0) {
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        }
      });

      if (!body) return;

      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<p class="hv-cart__empty">' + CFG.strings.cartEmpty + '</p>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      body.innerHTML = cart.items.map(function (item, i) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+\?)/i, '_160x$1') + '" alt="" width="74" height="74" loading="lazy">'
          : '';
        return '' +
          '<div class="hv-citem">' +
            '<div class="hv-citem__img">' + img + '</div>' +
            '<div class="hv-citem__main">' +
              '<div class="hv-citem__name">' + item.product_title + '</div>' +
              '<div class="hv-citem__price">' + formatMoney(item.final_line_price) + '</div>' +
              '<div class="hv-citem__row">' +
                '<div class="hv-citem__qty">' +
                  '<button type="button" data-hv-line-action="minus" data-hv-line="' + (i + 1) + '" data-hv-qty="' + item.quantity + '" aria-label="' + CFG.strings.decrease + '">' +
                    '<svg width="12" height="2" viewBox="0 0 12 2" fill="none" aria-hidden="true"><path d="M0 1h12" stroke="currentColor" stroke-width="1.5"/></svg>' +
                  '</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-hv-line-action="plus" data-hv-line="' + (i + 1) + '" data-hv-qty="' + item.quantity + '" aria-label="' + CFG.strings.increase + '">' +
                    '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"/></svg>' +
                  '</button>' +
                '</div>' +
                '<button type="button" class="hv-citem__remove" data-hv-line-action="remove" data-hv-line="' + (i + 1) + '">' + CFG.strings.remove + '</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      if (total) total.textContent = formatMoney(cart.total_price);
    }
  };

  /* ---------- 6. sticky add to cart ---------- */

  function initSticky() {
    var bar = $('[data-hv-sticky]');
    var anchor = $('[data-hv-sticky-anchor]');
    if (!bar) return;
    if (!anchor) { return; }
    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        bar.classList.toggle('is-visible', passed);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- 7. galeria produktu ---------- */

  function initGallery() {
    $$('[data-hv-gallery]').forEach(function (gallery) {
      var slides = $$('[data-hv-slide]', gallery);
      var thumbs = $$('[data-hv-thumb]', gallery);
      if (!slides.length) return;

      function show(index) {
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
          var vid = s.querySelector('video');
          if (vid && i !== index) vid.pause();
        });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === index);
          t.setAttribute('aria-selected', String(i === index));
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
        thumb.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); var n = thumbs[i + 1] || thumbs[0]; n.focus(); n.click(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); var p = thumbs[i - 1] || thumbs[thumbs.length - 1]; p.focus(); p.click(); }
        });
      });
      show(0);
    });
  }

  /* ---------- 8. wideo ---------- */

  function initVideo() {
    $$('[data-hv-video-toggle]').forEach(function (btn) {
      var wrap = btn.closest('[data-hv-video]');
      if (!wrap) return;
      var video = wrap.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () {
        if (video.paused) { video.play(); btn.setAttribute('aria-label', CFG.strings.pause); }
        else { video.pause(); btn.setAttribute('aria-label', CFG.strings.play); }
        wrap.classList.toggle('is-paused', video.paused);
      });
    });
  }

  /* ---------- 9. hotspoty + heat glow ---------- */

  function initShowcase() {
    $$('[data-hv-hotspot]').forEach(function (spot) {
      var dot = spot.querySelector('.hv-hotspot__dot');
      if (!dot) return;
      dot.addEventListener('click', function () {
        var open = spot.classList.contains('is-active');
        $$('[data-hv-hotspot]').forEach(function (s) { s.classList.remove('is-active'); });
        spot.classList.toggle('is-active', !open);
      });
    });

    var showcase = $('[data-hv-heat]');
    if (!showcase || reduce) return;
    var ticking = false;
    function update() {
      var rect = showcase.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var progress = 1 - Math.min(1, Math.max(0, (rect.top + rect.height * 0.4) / vh));
      showcase.style.setProperty('--hv-heat', (0.2 + progress * 0.7).toFixed(3));
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ---------- 10. count-up ---------- */

  function initCountUp() {
    var els = $$('[data-hv-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    if (reduce) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-hv-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-hv-count')) || 0;
        var start = performance.now();
        var dur = 900;
        (function step(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toString();
          if (p < 1) requestAnimationFrame(step);
        })(start);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 11. delikatny parallax produktu (tylko desktop) ---------- */

  function initTilt() {
    var target = $('[data-hv-tilt]');
    if (!target || reduce) return;
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

    var raf = null;
    var tx = 0, ty = 0;
    function onMove(e) {
      var rect = target.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      tx = ((e.clientX - cx) / rect.width) * 9;
      ty = ((e.clientY - cy) / rect.height) * 9;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        target.style.transform = 'translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0)';
        raf = null;
      });
    }
    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('mouseleave', function () { target.style.transform = ''; });
  }

  /* ---------- 12. quantity selectors ---------- */

  function initQty() {
    $$('[data-hv-qty-wrap]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-hv-qty-step]');
        if (!btn) return;
        var step = btn.getAttribute('data-hv-qty-step') === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- 13. płynne przewijanie kotwic ---------- */

  function initAnchors() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---------- start ---------- */

  function boot() {
    initReveal();
    initHeader();
    initMobileNav();
    initAccordions();
    Cart.init();
    initSticky();
    initGallery();
    initVideo();
    initShowcase();
    initCountUp();
    initTilt();
    initQty();
    initAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.HealvoCart = Cart;
})();
